module.exports = __webpack_public_path__ + "static/pellets-bag-e9c3a9488afc9856465f8c340af0dc47.jpg";